<template>
  <div class="product-components">
    <!--编辑弹窗 start-->
    <el-dialog
      class="drawer"
      top="0"
      width="800px"
      :title="formData.srv_id ? `${readOnly?'查看':'编辑'}产品` : '创建新产品'"
      :lock-scroll="true"
      :visible.sync="visible">

      <el-form
        v-loading="loading"
        ref="productForm"
        :model="formData"
        :rules="formRules"
        style="padding-right:30px"
        label-width="100px"><!-- size="mini" -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="ID">
              <el-input v-if="formData.srv_id" disabled v-model="formData.srv_id" class="jm-input220" />
              <span v-else>自动生成</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="编码" prop="srv_code">
              <el-input :disabled="!!formData.srv_id" v-model="formData.srv_code" class="jm-input220" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="品牌">
              <el-select
                v-model="formData.srv_category"
                :disabled="true"
                class="jm-input220"
                placeholder="请选择" clearable>
                <el-option
                  v-for="item in formDs.srv_category"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类目" prop="category_tree">
              <el-button type="text" @click="openCategoryTree">
                {{ categoryTreeName || '请设置产品类目' }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="产品名称" prop="srv_name">
              <el-input v-model="formData.srv_name" :disabled="readOnly" class="jm-input280" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="简称">
              <el-input v-model="formData.srv_title" :disabled="readOnly" class="jm-input280" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isTraining">
          <el-form-item label="类型标签">
            <el-input v-model="formData.srv_type" :disabled="readOnly" class="jm-input220" />
            <span class="jm-tips">如“1v10、卡课”等提示产品类型的标签</span>
          </el-form-item>
        </el-row>
        <el-row v-else>
          <el-col :span="12">
            <el-form-item label="课程类型">
              <el-select
                v-model="formData.srv_course_type"
                :disabled="readOnly"
                class="jm-input220"
                placeholder="请选择" clearable>
                <el-option
                  v-for="item in formDs.srv_course_type"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否全案">
              <el-select
                v-model="formData.srv_fullcase"
                :disabled="readOnly"
                class="jm-input220"
                placeholder="请选择" clearable>
                <el-option
                  v-for="item in formDs.srv_fullcase"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="产品简介">
              <el-input :disabled="readOnly" type="textarea" placeholder="请输入简介内容" v-model="formData.srv_content"
                        :autosize="{ minRows: 2, maxRows: 10 }"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品定价">
              <el-input
                v-model="formData.srv_amount"
                :disabled="readOnly"
                class="jm-input220"
                type="text"
                clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否需佣金">
              <el-select
                v-model="formData.need_commission"
                :disabled="readOnly"
                class="jm-input220"
                placeholder="请选择"
                clearable>
                <el-option
                  v-for="item in formDs.need_commission"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="定价单位">
              <el-input
                v-model="formData.srv_unit"
                :disabled="readOnly"
                class="jm-input220"
                type="text"
                clearable
                value="元"/>
              <span class="jm-tips">如：元、美元；也可以自定义说明：元/小时、元/周</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="排序">
              <el-input v-model="formData.srv_order" :disabled="readOnly" type="number" class="jm-input135" />
            </el-form-item>
            <el-form-item label="状态">
              <el-tag v-if="formData.is_del" type="danger">禁用</el-tag>
              <el-tag v-else type="success">启用</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!isTraining" style="width:100%">
          <el-col>
            <el-form-item label="支付科目">
              <el-select
                multiple
                v-model="formData.srv_class"
                :disabled="readOnly"
                style="width:100% !important"
                placeholder="请选择" clearable>
                <el-option
                  v-for="item in formDs.srv_class"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isJiemo || isQcrb">
          <el-col>
            <el-form-item label="费用限定">
              <!--添加按钮-->
              <el-button
                v-if="!readOnly"
                @click="openPrice"
                size="mini"
                style="float:right"
                type="warning" icon="el-icon-circle-plus">添加
              </el-button>
              <p class="jm-tips">前端录入时，单项费用将按价格范围校验</p>

              <el-table
                :data="boundaryPriceList"
                style="width: 100%;" size="mini">
                <el-table-column width="100" prop="label" label="费用名称"/>
                <el-table-column prop="priceText" label="价格范围"/>
                <el-table-column label="操作" v-if="!readOnly">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="editPrice(scope.$index, scope.row)" icon="el-icon-edit" plain>编辑
                    </el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="delPrice(scope.$index, scope.row)" icon="el-icon-delete" plain>删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveFormData" v-if="!readOnly">
          {{ formData.srv_id ? '保存' : '立即创建' }}
        </el-button>
        <el-button @click="hideDialog">取消</el-button>
      </div>
    </el-dialog>
    <!--编辑弹窗 end-->

    <!--费用明细弹窗-->
    <el-dialog width="600px" title="费用设置" :visible.sync="priceBoxShow">
      <el-form :model="priceData" ref="priceBoxForm" :rules="priceBoxRules" label-width="100px">
        <el-form-item label="费用名称" prop="label">
          <el-input
            placeholder="请输入内容"
            v-model="priceData.label"
            class="jm-input220"
            type="text"
            clearable />
        </el-form-item>
        <el-form-item label="价格范围">
          <el-radio-group v-model="priceData.type" @input="inputPriceType">
            <el-radio label="">固定</el-radio>
            <el-radio label="base">底价</el-radio>
            <el-radio label="range">范围</el-radio>
            <el-radio label="-1">不限</el-radio>
            <el-radio label="0">免费</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="priceData.type === '' || priceData.type === 'base'"
          prop="value">
          <el-input
            :placeholder="priceData.type === 'base' ? '请输入固定价格' : '请输入底价(最低价)'"
            v-model="priceData.value"
            class="jm-input175"
            type="number"
            clearable />
        </el-form-item>
        <el-form-item
          v-else-if="priceData.type === 'range'"
          prop="rangeValue"
        >
          <el-input
            placeholder="请输入启始价"
            v-model="priceData.value"
            class="jm-input135"
            type="number" clearable/>
          <span> ~ </span>
          <el-input
            placeholder="请输入最高价"
            v-model="priceData.value2"
            class="jm-input135"
            type="number" clearable/>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closePrice">取 消</el-button>
        <el-button type="primary" @click="modifyPrice">确 定</el-button>
      </span>
    </el-dialog>

    <!--类目选择弹窗-->
    <el-dialog width="600px" title="类目设置" :visible.sync="categoryBoxShow">
      <el-form :model="categoryData" ref="categoryBoxForm" label-width="100px">
        <el-form-item label="一级类目" prop="srv_mainclass" :rules="[
          { required: true, message: '一级类目不能为空' }
        ]">
          <el-select
            v-model="categoryData.srv_mainclass"
            class="jm-input220"
            placeholder="请选择"
            clearable>
            <el-option
              v-for="item in formDs.srv_mainclass"
              :key="item.id"
              :label="item.value"
              :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="二级类目" :prop="isTraining ? 'srv_collection' : 'srv_country'" :rules="[
          { required: true, message: '二级类目不能为空' }
        ]">
          <!-- 考培使用 srv_collection, 留学用 srv_country -->
          <el-select
            v-if="isTraining"
            v-model="categoryData.srv_collection"
            class="jm-input220"
            placeholder="请选择" clearable>
            <el-option
              v-for="item in formDs.srv_collection"
              :key="item.key"
              :label="item.name"
              :value="item.key"/>
          </el-select>
          <el-select
            v-else
            v-model="categoryData.srv_country"
            class="jm-input220"
            placeholder="请选择" clearable>
            <el-option
              v-for="item in formDs.srv_country"
              :key="item.key"
              :label="item.name"
              :value="item.key"/>
          </el-select>

          <span class="jm-tips">如需创建新语种请联系管理员</span>
        </el-form-item>
        <el-form-item label="三级类目" prop="srv_group" :rules="[
          { required: true, message: '三级类目不能为空' }
        ]">
          <el-autocomplete
            v-model="categoryData.srv_group"
            class="jm-input220"
            :fetch-suggestions="querySrvGroup"
            placeholder="请选择" clearable>
          </el-autocomplete>
          <span class="jm-tips">
            可选择已有类目或自行创建
          </span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="categoryBoxShow = false">取 消</el-button>
        <el-button type="primary" @click="modifyCategoryTree">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import { jmDictSelect, } from '@/components/tool';

export default {
  name: 'ProductForm',
  props: {
    formDs: {
      type: Object,
      default: null,
    },
    formData: {
      type: Object,
      default: null,
    },
    afterSaving: {
      type: Function,
      default: null,
    }
  },
  data() {
    // 价格校验
    const checkPriceValue = (rule, value, callback) => {
      let price = this.priceData.value;
      if (!price) {
        return callback(new Error('没有填写价格值'));
      }

      price = parseInt(price, 10);
      if (this.priceData.type === 'base' || this.priceData.type === '') {
        if (price <= 0) {
          return callback(new Error('价格值必须大于 0'));
        }
      } else if (this.priceData.type === 'range') {
        let price2 = this.priceData.value2;

        if (!price2) {
          return callback(new Error('价格范围没有填写'));
        }
        if (price < 0) {
          return callback(new Error('价格值不能小于 0'));
        }
        if (price >= price2) {
          return callback(new Error('价格范围必须正确有效'));
        }
      }
      callback();
    };

    // 类目校验
    const checkCategoryTree = (rule, value, callback) => {
      if (!this.categoryTreeName) {
        return callback(new Error('类目没有设置'));
      }
      callback();
    };

    return {
      visible: false,
      loading: false,
      formRules: {
        srv_code: [
          { required: true, message: '产品编码不能为空' }
        ],
        category_tree: [
          { required: true, validator: checkCategoryTree },
        ],
        srv_name: [
          { required: true, message: '产品名称不能为空' },
          { min: 4, message: '产品名称至少 4 个字符' }
        ],
      },
      categoryBoxShow: false, // 类目窗体
      categoryData: {
        srv_mainclass: '',
        srv_collection: '',
        srv_country: '',
        srv_group: '',
      },
      priceBoxShow: false, // 费用窗体
      priceBoxRules: {
        label: [
          { required: true, message: '费用名称不能为空' }
        ],
        value: [
          { required: true, validator: checkPriceValue }
        ],
        rangeValue: [
          { required: true, validator: checkPriceValue }
        ]
      },
      priceData: {
        index: 0,
        type: '',
        label: '',
        priceText: '',
        value: '',
        value2: ''
      },
    };
  },
  created() {
  },
  mounted() {
    this.getSearchDs();
  },
  methods: {
    /**
     * 获取字典数据
     */
    getSearchDs() {
      let category = this.formData.srv_category;
      if (!this.formDs) {
        this.loading = true;
        this.$http._post({
          url: '/index/product_center/searchDs',
          data: {
            category: category
          }
        }).then((data) => {
          this.formDs = data.data;
          this.loading = false;
        });
      }
    },
    /**
     * 打开窗体
     */
    showDialog() {
      this.visible = true;
    },
    /**
     * 隐藏窗体
     */
    hideDialog() {
      this.visible = false;
    },
    /**
     * 获取三级目录建议
     */
    querySrvGroup(query, callback) {
      let results = [];
      let secondKey = this.isTraining ? this.categoryData.srv_collection : this.categoryData.srv_country;
      if (this.categoryData.srv_mainclass) {
        let index = `${this.categoryData.srv_mainclass}-${secondKey}`;
        let category = this.formDs.category_list[index];
        if (category && Array.isArray(category.subGroup)) {
          category.subGroup.sort().forEach((value) => {
            results.push({ value: value });
          });
        }
      }
      callback(results);
    },
    openCategoryTree() {
      if (this.readOnly) return;

      this.categoryBoxShow = true;
      this.categoryData.srv_mainclass = this.formData.srv_mainclass;
      this.categoryData.srv_country = this.formData.srv_country;
      this.categoryData.srv_collection = this.formData.srv_collection;
      this.categoryData.srv_group = this.formData.srv_group;
    },
    /**
     * 修改类目分类
     */
    modifyCategoryTree() {
      this.$refs.categoryBoxForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认要更改产品类目?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.formData.srv_mainclass = this.categoryData.srv_mainclass;
            this.formData.srv_country = this.categoryData.srv_country;
            this.formData.srv_collection = this.categoryData.srv_collection;
            this.formData.srv_group = this.categoryData.srv_group;
            this.categoryBoxShow = false;
          });
        } else {
          this.$message.warning('请确保产品类目完整');
        }
      });
    },
    /**
     * 根据一个价格值，返回类型
     * - 底价 'base'
     * - 范围 'range'
     * - 不限 '-1'
     * - 免费 '0'
     * - 固定 ''
     */
    getBoundaryPriceText(formatPrice) {
      let priceType = this.getBoundaryPriceType(formatPrice);
      let [first, second] = formatPrice.split(',');
      switch (priceType) {
        case '-1':
          return '不限';
        case '0':
          return '免费';
        case 'base':
          return `≥${first}`;
        case 'range':
          return `${first}~${second}`;
        default:
          return first;
      }
    },
    getBoundaryPriceType(formatPrice) {
      if (formatPrice === '-1' || formatPrice === '0') {
        return formatPrice;
      }
      if (formatPrice.endsWith(',-1')) {
        return 'base';
      }
      if (formatPrice.indexOf(',') >= 0) {
        return 'range';
      }
      return '';
    },
    formatBoundaryPrice(price) {
      price += '';
      if (!/^(-?\d+),?(-?\d+)?$/.test(price)) {
        return '-1';
      }

      // 以 - 开始则全为 -1
      if (price.startsWith('-') || price.startsWith(',-')) return '-1';

      // 以下均是以非负数开始的情况
      if (price.indexOf(',') < 0) {
        return parseInt(price, 10) < 0 ? '-1' : price;
      }
      let [first, second] = price.split(',');

      // 第一个数肯定为0或正数
      if (!first || parseInt(first, 10) === 0) first = 0;

      // 第二个数负数或没有均为-1
      if (!second || parseInt(second, 10) < 0) second = -1;

      // 重新合成
      price = [first, parseInt(second, 10)].join(',');

      // ',0' 结尾则取消
      if (price.endsWith(',0')) { price = price.replace(',0', ''); }

      // -1 特殊形式
      if (price === '0,-1') { price = '-1'; }

      return price;
    },
    // 费用明细
    openPrice() {
      this.priceBoxShow = true;
      this.priceData = {
        index: this.boundaryPriceList.length,
        label: '',
        priceText: '',
        priceValue: '',
        type: '',
        value: '',
        value2: ''
      };
    },
    // 编辑费用明细
    editPrice(index, row) {
      this.priceBoxShow = true;
      this.priceData = Object.assign({ index: index }, row);
    },
    // 费用明显选择类型
    inputPriceType() {
      this.priceData.value = '';
      this.priceData.value2 = '';
    },
    delPrice(index) {
      this.formData.srv_price.splice(index, 1);
    },
    closePrice() {
      this.priceBoxShow = false;
    },
    modifyPrice() {
      this.$refs.priceBoxForm.validate((valid) => {
        if (valid) {
          let price;
          switch (this.priceData.type) {
            case 'base':
              price = `${this.priceData.value},-1`;
              break;
            case 'range':
              price = `${this.priceData.value},${this.priceData.value2}`;
              break;
            case '-1':
            case '0':
              price = this.priceData.type;
              break;
            case '':
            default:
              price = this.priceData.value;
              break;
          }

          // 修改字段，必须用 Vue.set 才能 computed 数组
          this.$set(this.formData.srv_price, this.priceData.index, {
            label: this.priceData.label,
            value: price
          });
          this.closePrice();
        } else {
          this.$message.warning('请确保费用设置完整');
        }
      });
    },
    /**
     * 保存表单
     */
    saveFormData() {
      this.$refs.productForm.validate((valid) => {
        if (valid) {
          this.$http._post({
            url: '/index/product_center/save',
            data: this.formData
          }).then((data) => {
            this.$message.success(data.data);
            this.hideDialog();
            // 执行一个来自于父组件的调用
            this.afterSaving();
          });
        }
      });
    },
  },
  computed: {
    isJiemo() {
      return this.formData.srv_category === 'SRV_JIEMO';
    },
    isQcrb() {
      return this.formData.srv_category === 'SRV_QCRB';
    },
    isTraining() {
      return this.formData.srv_category === 'SRV_TRAINING';
    },
    isOldService() {
      return this.formData.srv_category === 'SRV_SERVICE_OLD';
    },
    readOnly() {
      return this.isOldService || !!this.formData.is_del;
    },
    boundaryPriceList() {
      let srvPrice = this.formData.srv_price;
      if (Array.isArray(srvPrice) && srvPrice.length > 0) {
        let result = [];
        srvPrice.forEach((o) => {
          let formatPrice = this.formatBoundaryPrice(o.value);
          let [value, value2] = formatPrice.split(',');

          result.push({
            label: o.label,
            value: value,
            value2: value2,
            type: this.getBoundaryPriceType(formatPrice),
            priceValue: formatPrice,
            priceText: this.getBoundaryPriceText(formatPrice)
          });
        });
        return result;
      }
      return [];
    },
    categoryTreeName() {
      if (this.formData.srv_mainclass) {
        let secondKey = this.isTraining ? this.formData.srv_collection : this.formData.srv_country;
        let index = `${this.formData.srv_mainclass}-${secondKey}`;
        let category = this.formDs.category_list[index];

        if (category && category.mainName && category.subName && this.formData.srv_group) {
          return [category.mainName, category.subName, this.formData.srv_group].join(' / ');
        }
      }
      return '';
    },
  },
  components: {
    jmDictSelect
  }
};
</script>

<style scoped>
span.jm-tips {
  color: #aaa;
  margin-left: 10px;
}
p.jm-tips {
  color: #aaa;
  margin-left: 0;
}
.jm-tag {
  margin-right:10px;
}
/* 抽屉样式 */
.drawer>>>.el-dialog {
  position: absolute !important;
  right: 0;
  height: 100%;
}
.drawer>>>.el-dialog__body {
  height: calc(100% - 140px);
  overflow: scroll;
  overflow-x: hidden;
  overflow-y: scroll;
}
.drawer>>>.dialog-footer {
  position: sticky;
  bottom: 10px;
}

</style>
